import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AccordionInfoProductComponent } from 'app/shared/modals-results-categories/accordion-info-product/accordion-info-product.component';
import { AccordionConfig, AccordionItem } from 'app/shared/modals-results-categories/accordion-info-product/accordion-info.interface';
import { ICancellationPolicyModalResultsDisplayData } from 'model/view-models/results/product-card/price-display-data.interface';

/**
 * Parse a "YYYY-MM-DD HH:mm" or ISO datetime string and return a `Date`,
 * or `null` if the value is falsy or unparseable. Used as a defensive
 * helper for ride-hailing flows where the search-box leaves
 * `infoTransfer.firstArrivalDate` as `null` and the only place the
 * service time is available is on `product.timing.entry.entryDepartureDatetime`.
 */
function parseDateTime(value: string | null | undefined): Date | null {
  if (!value) return null;
  const d = new Date(String(value).replace(' ', 'T'));
  return isNaN(d.getTime()) ? null : d;
}

@Component({
  selector: 'usb-vehicle-info-transfer',
  templateUrl: './vehicle-info-transfer.component.html',
  styleUrls: ['./vehicle-info-transfer.component.scss']
})
export class VehicleInfoTransferComponent implements OnInit {

  @ViewChild('politicsAccordion') politicsAccordion: any;
  @ViewChild('politicsSection') politicsSection!: ElementRef;
  @Input() product: any;
  @Input() infoTransfer: any;
  @Input() numberOfSeats: any;
  @Input() numberOfDoors: any;
  @Input() maxPax: any;
  @Input() numberLargeSuitcases: any;
  @Input() numberMediumSuitcases: any;
  @Input() numberHandBag: any;
  @Input() totalQty: any;
  @Input() currencySelected: any;
  @Input() productSelect: boolean;
  @Input() fliyingInfo: any;
  @Input() formTransport: any;
  @Input() payload: any;
  @Input() currencies: any[] = [];
  @Input() currencyAgency: any;
  @Input() clientSetting: any;
  @Input() quote: boolean = true;




  @Output() continueEmit = new EventEmitter<any>();
  @Output() accordionStateChange = new EventEmitter<{ isOpen: boolean, contentHeight: number }>();

  @ViewChild('accordionComponent') accordionComponent!: AccordionInfoProductComponent;
  @ViewChild('accordionContent', { read: ElementRef }) accordionContent!: ElementRef;
  backgroundSelect: any;
  buttonColorActive: any;
  buttonTextActive: any;
  roundTripTime: any;
  additionalPadding: number = 0;
  basePadding: number = 110;

  cancellationData!: ICancellationPolicyModalResultsDisplayData;
  accordionItemsData!: AccordionItem[];
  accordionConfigData!: AccordionConfig;
  descriptionData: SafeHtml = '';

    isMainExpanded = true;
  isMainExpandedExcutiveAction: boolean[] = [];

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    const bookingFlow_sidebar = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundSelect = JSON.parse(this.clientSetting?.clients_setting_app_booking?.bookingFlow_body).card_background_price;
    this.buttonColorActive = bookingFlow_sidebar?.background_color_header;
    this.buttonTextActive = bookingFlow_sidebar?.color;
    this.validateEntryAndReturnTime();

    this.cancellationData = this.cancellationPolicies();
    this.accordionItemsData = this.accordionItems();
    this.accordionConfigData = this.accordionConfig();
    this.descriptionData = this.transportDescription();
  }

  /**
 * Emite el evento 'continueEmit' para notificar que se debe continuar con el proceso.
 */
  continue() {
    this.continueEmit.emit();
  }


/**
 * Verifica si el valor numérico pasado es mayor que 0.
 *
 * @param vehicleInfo - Valor que se quiere verificar
 * @returns boolean - true si el valor numérico es mayor que 0, false en caso contrario
 */
  verifyConditionInfo(vehicleInfo: any): boolean {
    return Number(vehicleInfo) > 0;
  }

  /**
 * Abre o cierra el acordeón de políticas y, si se está abriendo,
 * realiza un scroll suave hacia la sección correspondiente.
 */
  openPolitics(): void {

    // Abrir el panel de políticas
    this.accordionComponent.openItem('policies');

    // Hacer scroll al elemento
    setTimeout(() => {
      const element = document.querySelector('.accordion-item-policies');
      element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 100);
  }

  /**
 * Extrae la hora y minutos de una cadena datetime en formato ISO (YYYY-MM-DDTHH:mm:ss).
 *
 * @param dateTime - Cadena con fecha y hora completa en formato ISO
 * @returns string - Hora en formato 'HH:mm', o cadena vacía si no hay valor válido
 */
_extractHourMinute(dateTime: string): string {
  if (dateTime) {
    return dateTime.slice(11, 16); // 'HH:MM' empieza en el índice 11
  }
  return '';
}

/**
 * Determina si las amenidades del producto deben mostrarse.
 * Retorna true si el producto tiene amenidades incluidas o amenidades marcadas como incluidas.
 *
 * @returns boolean - true si hay amenidades visibles, false en caso contrario
 */
amenitiesVisible(): boolean {

  if(this.product) {
    if(
      this.product.amenities.some(c => c?.included === true) ||
      this.product.amenitiesIncluded.length > 0
      )
      {
      return true;
      }
  }
  return false;

}

/**
 * Extrae el nombre del transporte según el formulario y el tipo (origen o destino).
 * Formatea el nombre según el tipo de ubicación (hotel, aeropuerto, destino).
 *
 * @param form - Objeto con la información del transporte
 * @param type - Cadena que indica si es 'origin' o 'destination'
 * @returns string - Nombre formateado para mostrar
 */
  extractNameTransport(form: any, type: string): string {

    switch(type) {
      case 'origin':
        switch(this.payload.transfers.pickupLocation.type) {
          case 'hotel':
            return form.name;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'destination':
            return form.city_name;
        }
      case 'destination':
        switch(this.payload.transfers.dropoffLocation.type) {
          case 'hotel':
            return form.name;
          case 'airport':
            return `${form.name} (${form.iata})`;
          case 'destination':
            return form.city_name;
        }
    }

  }

  cancellationPolicies(): ICancellationPolicyModalResultsDisplayData {
    return {
      rateClass: this.product?.pricing.rateClass,
      cancellationPolicies: this.product?.timing?.entry?.entryCancellationPolicies || [],
      currencyCancellation: this.product?.pricing?.currency,
      amount: this.product?.timing?.entry?.entryCancellationPolicies?.find(c => c.amount > 0)?.amount || 0,
      from: this.product?.timing?.entry?.entryCancellationPolicies?.find(c => c.amount > 0)?.from || 'N/A',
      cancellationFree: this.product?.timing?.entry?.entryCancellationPolicies?.some(c => Number(c.amount) === 0),
      // For ride-hailing flows `infoTransfer.firstArrivalDate` is null; fall
      // back to the service time the backend attached to the vehicle.
      arrivalDate:
        this.infoTransfer?.firstArrivalDate ||
        this.product?.timing?.entry?.entryDepartureDatetime ||
        null
    }
  }

    baseMargin: number = 110;

 onAccordionToggle(event: any): void {
    const index = event?.index ?? event;

    this.isMainExpandedExcutiveAction[index] = !this.isMainExpandedExcutiveAction[index];

    // setTimeout(() => {
    //   if (this.isMainExpandedExcutiveAction[index] && this.accordionComponent) {
    //     // Obtener la altura del contenido
    //     const contentHeight = this.accordionComponent.getItemContentHeight(index);

    //     // ✅ Acceder al elemento con clase .usb-accordion.animated dentro del acordeón
    //     const accordionElement = this.accordionComponent.el?.nativeElement?.querySelector('.usb-accordion.animated');

    //     if (accordionElement) {
    //       const totalMargin = 110;
    //       (accordionElement as HTMLElement).style.marginBottom = `${totalMargin}px`;
    //     }

    //     this.accordionStateChange.emit({ isOpen: true, contentHeight });
    //   } else {
    //     // Cuando se cierra, restaurar el margin
    //     const accordionElement = this.accordionComponent.el?.nativeElement?.querySelector('.usb-accordion.animated');
    //     if (accordionElement) {
    //       (accordionElement as HTMLElement).style.marginBottom = '0';
    //     }
    //     this.accordionStateChange.emit({ isOpen: false, contentHeight: 0 });
    //   }
    // }, 200);
  }

    accordionItems(): AccordionItem[] {
      return [
        {
          id: 'description',
          title: 'Descripción',
          icon: 'assets/icons/description.svg',
          data: { description: this.transportDescription }
        },
        {
          id: 'policies',
          title: 'Políticas de Cancelación y Penalidades',
          icon: 'assets/icons/policy.svg',
          data: { policies: this.cancellationPolicies }
        }
      ];


      }

      accordionConfig(): AccordionConfig {
       return {
        multiple: false,
        animated: true,
        showArrows: true,
        borderTop: true,
        defaultOpen: ['description']
       }
      };




      transportDescription(): SafeHtml {
          const rawFirstArrival =
            this.infoTransfer?.firstArrivalDate ||
            this.product?.timing?.entry?.entryDepartureDatetime;

          const parsedDate = parseDateTime(rawFirstArrival);
          const formattedDate = parsedDate
            ? formatDate(parsedDate, 'EEEE dd MMM yyyy', 'es')
            : 'Fecha a confirmar';

          // Time-of-day (e.g. "13:14"). Same fallback logic as the date.
          const firstTimeValue =
            this.infoTransfer?.firstTime ||
            (rawFirstArrival ? String(rawFirstArrival).split(/[ T]/)[1] : null) ||
            '';
          const displayTime = firstTimeValue || 'horario a confirmar';

          const html = `
              <div style="background-color: white;margin-top: -15px">
                <div class="d-flex align-items-start">
                  <i class="bi bi-check" style="font-size: 1.5rem;margin-top: -7px"></i>
                  <div class="d-flex flex-column" style="gap: 8px;">
                  <p class="mb-0 usb-modal-text--body">De ${this.infoTransfer.firstOrigin.name}</p>
                  <p class="mb-0 usb-modal-text--body" style="font-weight: 600;">${formattedDate} - ${displayTime}</p>
                  </div>
                </div>

                <div class="d-flex align-items-start mt-3 ">
                    <i class="bi bi-check"  style="font-size: 1.5rem;margin-top: -7px"></i>
                    <div class="d-flex flex-column" style="gap: 8px;">
                      <p *ngIf="product?.vehicle?.name" class="mb-0 usb-modal-text--body" style="font-weight: 600;">
                        Traslado ${this.product?.transferType} en: ${this.product?.vehicle?.name}</p>
                      <p class="mb-0 usb-modal-text--body">Punto de partida: <span
                      style="font-weight: 600">${this.infoTransfer.firstOrigin.name}</span></p>
                      <p class="mb-0 usb-modal-text--body">Punto de llegada: <span
                      style="font-weight: 600; text-transform: capitalize;">${this.infoTransfer.firstDestination.name}</span></p>
                    </div>
                </div>

                <div class="d-flex align-items-center mt-3">
                    <i class="bi bi-check"  style="font-size: 1.5rem"></i>
                   <p class="mb-0  usb-modal-text--body">Duración aproximada: <span
                    style="font-weight: 600;">${this.product?.timing?.entry?.entryTravelTime} minutos</span></p>
                </div>

                <div class="d-flex align-items-center mt-3">
                    <i class="bi bi-check"  style="font-size: 1.5rem"></i>
                  <p class="mb-0  usb-modal-text--body">Capacidad del vehículo: <span style="font-weight: 600;">Hasta
                    ${this.product?.vehicle.maxPax} pasajeros</span></p>
                </div>


                <div class="d-flex align-items-center mt-3">
                    <i class="bi bi-check"  style="font-size: 1.5rem"></i>
                   <p class="mb-0  usb-modal-text--body">Equipaje: <span style="font-weight: 600;">Hasta
                    ${this.product?.vehicle?.bag.maxBag} por vehículo - Hasta valijas(s) de mano por vehículo</span></p>
                </div>









              </div>
            `;
            return this.sanitizer.bypassSecurityTrustHtml(html);
      }

         /**
   * Genera la suma total de los minutos
   * En el caso que solo sea ida y vuelta, indicará la suma total de entryTravelTime y returnTravelTime.
   * Si es solo ida, mostrara solo el entryTravelTime.
   */
  validateEntryAndReturnTime(): void {
    const entryTime = this.product.timing.entry.entryTravelTime;
    const returnTime = this.product.timing.return.returnTravelTime;

    if (entryTime && !returnTime) {
      this.roundTripTime = Number(entryTime);
    } else {
      this.roundTripTime = Number(entryTime) + Number(returnTime);
    }
  }
                // <p class="mb-0 mt-3 text-description-accordion">Vuelta: <span
                //     style="font-weight: 600">${this.infoTransfer.secondArrivalDate} - ${this.infoTransfer.secondTime}</span></p>

  /**
   * Resolved `firstArrivalDate` for templates: falls back to the service
   * datetime the backend attached to the vehicle. Returns `null` if even
   * that is missing so the template can render a placeholder instead of
   * crashing the `date` pipe.
   */
  get resolvedFirstArrivalDate(): string | null {
    return (
      this.infoTransfer?.firstArrivalDate ||
      this.product?.timing?.entry?.entryDepartureDatetime ||
      null
    );
  }

  /**
   * Same as `resolvedFirstArrivalDate` but for the return leg.
   */
  get resolvedSecondArrivalDate(): string | null {
    return (
      this.infoTransfer?.secondArrivalDate ||
      this.product?.timing?.return?.returnDepartureDatetime ||
      null
    );
  }

  getTimeDropoff(): string {
    const entry = Number(this.product?.timing?.entry?.entryTravelTime) || 0;
    const returnLeg = Number(this.product?.timing?.return?.returnTravelTime) || 0;
    const totalMins = returnLeg > 0 ? returnLeg : entry;

    const isRoundTrip = returnLeg > 0;

    const baseStr: string = isRoundTrip
      ? (this.infoTransfer?.secondTime ||
         this._extractHourMinute(this.product?.timing?.return?.returnDepartureDatetime) ||
         this._extractHourMinute(this.product?.timing?.entry?.returnDepartureDatetime))
      : (this.infoTransfer?.firstTime ||
         this._extractHourMinute(this.product?.timing?.entry?.entryDepartureDatetime));

    if (!baseStr) return '';

    const parts = baseStr.split(':').map(Number);
    if (parts.length < 2 || parts.some(isNaN)) {
      return '';
    }
    const [h, m] = parts;
    const total = h * 60 + m + totalMins;
    const hh = String(Math.floor(total / 60) % 24).padStart(2, '0');
    const mm = String(total % 60).padStart(2, '0');
    return `${hh}:${mm}`;
  }

  hasIncludedAmenities(): boolean {
  return this.product?.amenities?.some(amenity => amenity?.included === true) || false;
}
// En tu componente
getArrivalFlight(): any {
  if (!this.fliyingInfo || !Array.isArray(this.fliyingInfo)) {
    return null;
  }

  // Solo mostrar vuelo si el destino es un aeropuerto
  const isDestinationAirport = this.infoTransfer?.firstOrigin?.type=== 'airport';
  if (!isDestinationAirport) {
    return null;
  }

  const transferDate = this.infoTransfer?.firstArrivalDate;
  if (!transferDate) {
    return null;
  }

  const transferDateStr = new Date(transferDate).toISOString().split('T')[0];

  // Buscar vuelo de llegada (arrivalIn) que coincida con la fecha
  const arrivalFlight = this.fliyingInfo.find(flight => {
    if (flight.arrivalIn) {
      const flightDateStr = new Date(flight.arrivalIn).toISOString().split('T')[0];
      return flightDateStr === transferDateStr;
    }
    return false;
  });

  return arrivalFlight || null;
}

getDepartureFlight(): any {
  if (!this.fliyingInfo || !Array.isArray(this.fliyingInfo)) {
    return null;
  }

  // Solo mostrar vuelo si el origen es un aeropuerto Y el tipo es roundTrip
  const isOriginAirport =  this.infoTransfer?.firstDestination?.type === 'airport';
  const isRoundTrip = this.infoTransfer?.type === 'roundTrip';

  if (!isOriginAirport || !isRoundTrip) {
    return null;
  }

  const transferDate = this.infoTransfer?.firstArrivalDate;
  if (!transferDate) {
    return null;
  }

  const transferDateStr = new Date(transferDate).toISOString().split('T')[0];

  // Buscar vuelo de salida (departureOut) que coincida con la fecha
  const departureFlight = this.fliyingInfo.find(flight => {
    if (flight.departureOut) {
      const flightDateStr = new Date(flight.departureOut).toISOString().split('T')[0];
      return flightDateStr === transferDateStr;
    }
    return false;
  });

  return departureFlight || null;
}
}
